// extracted by mini-css-extract-plugin
export default {"appLoading":"App_appLoading__-gQHW","appError":"App_appError__SRFWj"};